import {
  post, get, put, remove
} from '@api';
import { Store } from 'react-notifications-component';
import {
  COMMON_DATA_DELETE_FAIL,
  COMMON_DATA_DELETE_SUCCESS,
  COMMON_DATA_UPDATE_FAIL,
  COMMON_DATA_UPDATE_SUCCESS
} from '../../constants/notification-settings';

export const FETCH_DISCOUNTS_START = 'FETCH_DISCOUNTS_START';
export const FETCH_DISCOUNTS_SUCCESS = 'FETCH_DISCOUNTS_SUCCESS';
export const FETCH_DISCOUNTS_FAIL = 'FETCH_DISCOUNTS_FAIL';

export const WRITE_DISCOUNT_START = 'WRITE_DISCOUNT_START';
export const WRITE_DISCOUNT_SUCCESS = 'WRITE_DISCOUNT_SUCCESS';
export const WRITE_DISCOUNT_FAIL = 'WRITE_DISCOUNT_FAIL';

export const CHANGE_DISCOUNT_START = 'CHANGE_DISCOUNT_START';
export const CHANGE_DISCOUNT_SUCCESS = 'CHANGE_DISCOUNT_SUCCESS';
export const CHANGE_DISCOUNT_FAIL = 'CHANGE_DISCOUNT_FAIL';

export const UPDATE_DISCOUNT_POSITION_SUCCESS = 'UPDATE_DISCOUNT_POSITION_SUCCESS';
export const UPDATE_DISCOUNT_FIELD_POSITION_SUCCESS = 'UPDATE_DISCOUNT_FIELD_POSITION_SUCCESS';
export const UPDATE_DISCOUNTS_LIST = 'UPDATE_DISCOUNTS_LIST';

export const DELETE_DISCOUNT_START = 'DELETE_DISCOUNT_START';
export const DELETE_DISCOUNT_SUCCESS = 'DELETE_DISCOUNT_SUCCESS';
export const DELETE_DISCOUNT_FAIL = 'DELETE_DISCOUNT_FAIL';

export const UPDATE_DISCOUNTS_SUCCESS = 'UPDATE_DISCOUNTS_SUCCESS';
export const WRITE_DISCOUNTS_SUCCESS = 'WRITE_DISCOUNTS_SUCCESS';
export const FETCH_DISCOUNT_SUCCESS = 'FETCH_DISCOUNT_SUCCESS';

export const TOGGLE_ENTITY_SELECTION = 'TOGGLE_ENTITY_SELECTION';
export const TOGGLE_CATALOG_OPEN = 'TOGGLE_CATALOG_OPEN';
export const REMOVE_CONDITION = 'REMOVE_CONDITION';
export const SET_INITIAL_DATA = 'SET_INITIAL_DATA';
export const CLEAR_ALL_SELECTIONS = 'CLEAR_ALL_SELECTIONS';

export const FETCH_COUPONS_START = 'FETCH_COUPONS_START';
export const FETCH_COUPONS_SUCCESS = 'FETCH_COUPONS_SUCCESS';
export const FETCH_COUPONS_FAIL = 'FETCH_COUPONS_FAIL';

export const CREATE_COUPON_START = 'CREATE_COUPON_START';
export const CREATE_COUPON_SUCCESS = 'CREATE_COUPON_SUCCESS';
export const CREATE_COUPON_FAIL = 'CREATE_COUPON_FAIL';

export const GENERATE_COUPONS_START = 'GENERATE_COUPONS_START';
export const GENERATE_COUPONS_SUCCESS = 'GENERATE_COUPONS_SUCCESS';
export const GENERATE_COUPONS_FAIL = 'GENERATE_COUPONS_FAIL';

export const DELETE_COUPON_START = 'DELETE_COUPON_START';
export const DELETE_COUPON_SUCCESS = 'DELETE_COUPON_SUCCESS';
export const DELETE_COUPON_FAIL = 'DELETE_COUPON_FAIL';

export const DELETE_COUPONS_START = 'DELETE_COUPONS_START';
export const DELETE_COUPONS_SUCCESS = 'DELETE_COUPONS_SUCCESS';
export const DELETE_COUPONS_FAIL = 'DELETE_COUPONS_FAIL';

export const FETCH_DISCOUNT_SETTINGS_START = 'FETCH_DISCOUNT_SETTINGS_START';
export const FETCH_DISCOUNT_SETTINGS_SUCCESS = 'FETCH_DISCOUNT_SETTINGS_SUCCESS';
export const FETCH_DISCOUNT_SETTINGS_FAIL = 'FETCH_DISCOUNT_SETTINGS_FAIL';

export const UPDATE_DISCOUNT_SETTINGS_START = 'UPDATE_DISCOUNT_SETTINGS_START';
export const UPDATE_DISCOUNT_SETTINGS_SUCCESS = 'UPDATE_DISCOUNT_SETTINGS_SUCCESS';
export const UPDATE_DISCOUNT_SETTINGS_FAIL = 'UPDATE_DISCOUNT_SETTINGS_FAIL';

const fetchDiscountsStart = () => ({
  type: FETCH_DISCOUNTS_START,
});

export const fetchDiscountsSuccess = (data) => ({
  type: FETCH_DISCOUNTS_SUCCESS,
  payload: data,
});

const fetchDiscountsFail = (err) => ({
  type: FETCH_DISCOUNTS_FAIL,
  payload: err,
});

const writeDiscountStart = () => ({
  type: WRITE_DISCOUNT_START
});

export const writeDiscountSuccess = (discount) => ({
  type: WRITE_DISCOUNT_SUCCESS,
  payload: discount
});

const writeDiscountFail = (err) => ({
  type: WRITE_DISCOUNT_FAIL,
  payload: err
});

const changeDiscountStart = () => ({
  type: CHANGE_DISCOUNT_START
});

export const changeDiscountSuccess = (discount) => ({
  type: CHANGE_DISCOUNT_SUCCESS,
  payload: discount
});

export const updateDiscountsList = (discount) => ({
  type: UPDATE_DISCOUNTS_LIST,
  payload: discount
});

const changeDiscountFail = (err) => ({
  type: CHANGE_DISCOUNT_FAIL,
  payload: err
});

const deleteDiscountStart = () => ({
  type: DELETE_DISCOUNT_START,
});

const deleteDiscountSuccess = (id) => ({
  type: DELETE_DISCOUNT_SUCCESS,
  payload: id,
});

const deleteDiscountFail = (err) => ({
  type: DELETE_DISCOUNT_FAIL,
  payload: err,
});

export const updateDiscountsSuccess = (payload) => ({
  type: UPDATE_DISCOUNTS_SUCCESS,
  payload
});

export const writeDiscountsSuccess = (payload) => ({
  type: WRITE_DISCOUNTS_SUCCESS,
  payload
});

const fetchDiscountById = (data) => ({
  type: FETCH_DISCOUNT_SUCCESS,
  payload: data,
});

export const toggleEntitySelection = (conditionId, entityId, isNestedValue = false) => ({
  type: TOGGLE_ENTITY_SELECTION,
  payload: { conditionId, entityId, isNestedValue },
});

export const toggleCatalogOpen = (conditionId, catalogId) => ({
  type: TOGGLE_CATALOG_OPEN,
  payload: { conditionId, catalogId },
});

export const removeCondition = (conditionId) => ({
  type: REMOVE_CONDITION,
  payload: conditionId,
});

export const setInitialData = (conditionId, entities = []) => ({
  type: SET_INITIAL_DATA,
  payload: { conditionId, entities },
});

export const clearAllSelections = () => ({
  type: CLEAR_ALL_SELECTIONS,
});

const fetchCouponsStart = () => ({
  type: FETCH_COUPONS_START,
});

export const fetchCouponsSuccess = (data, append = false) => ({
  type: FETCH_COUPONS_SUCCESS,
  payload: { ...data, append },
});

const fetchCouponsFail = (err) => ({
  type: FETCH_COUPONS_FAIL,
  payload: err,
});

const createCouponStart = () => ({
  type: CREATE_COUPON_START,
});

export const createCouponSuccess = (data) => ({
  type: CREATE_COUPON_SUCCESS,
  payload: data,
});

const createCouponFail = (err) => ({
  type: CREATE_COUPON_FAIL,
  payload: err,
});

const generateCouponsStart = () => ({
  type: GENERATE_COUPONS_START,
});

export const generateCouponsSuccess = (data) => ({
  type: GENERATE_COUPONS_SUCCESS,
  payload: data,
});

const generateCouponsFail = (err) => ({
  type: GENERATE_COUPONS_FAIL,
  payload: err,
});

const deleteCouponStart = () => ({
  type: DELETE_COUPON_START,
});

export const deleteCouponSuccess = (id) => ({
  type: DELETE_COUPON_SUCCESS,
  payload: id,
});

const deleteCouponFail = (err) => ({
  type: DELETE_COUPON_FAIL,
  payload: err,
});

const deleteCouponsStart = () => ({
  type: DELETE_COUPONS_START,
});

export const deleteCouponsSuccess = (ids) => ({
  type: DELETE_COUPONS_SUCCESS,
  payload: ids,
});

const deleteCouponsFail = (err) => ({
  type: DELETE_COUPONS_FAIL,
  payload: err,
});

const fetchDiscountSettingsStart = () => ({
  type: FETCH_DISCOUNT_SETTINGS_START,
});

export const fetchDiscountSettingsSuccess = (data) => ({
  type: FETCH_DISCOUNT_SETTINGS_SUCCESS,
  payload: data,
});

const fetchDiscountSettingsFail = (err) => ({
  type: FETCH_DISCOUNT_SETTINGS_FAIL,
  payload: err,
});

const updateDiscountSettingsStart = () => ({
  type: UPDATE_DISCOUNT_SETTINGS_START,
});

export const updateDiscountSettingsSuccess = (data) => ({
  type: UPDATE_DISCOUNT_SETTINGS_SUCCESS,
  payload: data,
});

const updateDiscountSettingsFail = (err) => ({
  type: UPDATE_DISCOUNT_SETTINGS_FAIL,
  payload: err,
});

export const fetchDiscounts = ({ limit, offset, lang }) => async (dispatch) => {
  dispatch(fetchDiscountsStart());
  try {
    const result = await get(`/discounts?limit=${limit}&offset=${offset}&langCode=${lang}`);
    dispatch(fetchDiscountsSuccess(result.data));
  } catch (e) {
    dispatch(fetchDiscountsFail(e));
  }
};

export const fetchDiscountsById = (id, lang) => async (dispatch) => {
  dispatch(fetchDiscountsStart());
  try {
    const result = await get(`/discounts/${id}?langCode=${lang}`);
    dispatch(fetchDiscountById(result.data));
    return result.data;
  } catch (e) {
    dispatch(fetchDiscountsFail(e));
    return false;
  }
};

export const writeDiscount = (newDiscount, translations, setNewItemProcess) => async (dispatch) => {
  dispatch(writeDiscountStart());
  try {
    const result = await post('/discounts', newDiscount);
    dispatch(writeDiscountSuccess(result.data));
    setNewItemProcess((prev) => prev.filter((elId) => elId !== newDiscount.identifier));
    Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    return result.data;
  } catch (e) {
    dispatch(writeDiscountFail(e));
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    return false;
  }
};

export const changeDiscount = (data, translations, silent = true) => async (dispatch) => {
  dispatch(changeDiscountStart());
  try {
    await put(`/discounts/${data.id}`, data);
    dispatch(changeDiscountSuccess(data));
    if (!silent) {
      Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    }
    return data;
  } catch (e) {
    dispatch(changeDiscountFail(e));
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    return false;
  }
};

export const deleteDiscount = (id, translations) => async (dispatch) => {
  dispatch(deleteDiscountStart());
  try {
    await remove(`/discounts/${id}`);
    dispatch(deleteDiscountSuccess(id));
    Store.addNotification(COMMON_DATA_DELETE_SUCCESS(translations));
  } catch (e) {
    dispatch(deleteDiscountFail(e));
    Store.addNotification(COMMON_DATA_DELETE_FAIL(translations));
  }
};

export const fetchCoupons = (discountId, limit, offset, append = false) => async (dispatch) => {
  if (!discountId) return;

  dispatch(fetchCouponsStart());
  try {
    const result = await get(`/discounts/${discountId}/coupons`, {
      params: { limit, offset },
    });
    dispatch(fetchCouponsSuccess(result.data, append));
    return result.data;
  } catch (e) {
    dispatch(fetchCouponsFail(e));
    return null;
  }
};

export const createCoupon = (discountId, code, translations) => async (dispatch) => {
  if (!discountId) return false;

  dispatch(createCouponStart());
  try {
    const result = await post(`/discounts/${discountId}/coupons`, { code });
    dispatch(createCouponSuccess(result.data));
    Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    return result.data;
  } catch (e) {
    dispatch(createCouponFail(e));
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    return false;
  }
};

export const generateCouponsByMask = (discountId, mask, quantity, translations) => async (dispatch) => {
  if (!discountId) return false;

  dispatch(generateCouponsStart());
  try {
    const result = await post(`/discounts/${discountId}/coupons/generate`, { mask, quantity });
    dispatch(generateCouponsSuccess(result.data));
    Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    return result.data;
  } catch (e) {
    dispatch(generateCouponsFail(e));
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    return false;
  }
};

export const deleteCoupon = (discountId, couponId, translations) => async (dispatch) => {
  if (!discountId) return false;

  dispatch(deleteCouponStart());
  try {
    await remove(`/discounts/${discountId}/coupons/${couponId}`);
    dispatch(deleteCouponSuccess(couponId));
    Store.addNotification(COMMON_DATA_DELETE_SUCCESS(translations));
    return true;
  } catch (e) {
    dispatch(deleteCouponFail(e));
    Store.addNotification(COMMON_DATA_DELETE_FAIL(translations));
    return false;
  }
};

export const deleteCoupons = (discountId, ids, translations) => async (dispatch) => {
  if (!discountId) return false;

  dispatch(deleteCouponsStart());
  try {
    await remove(`/discounts/${discountId}/coupons`, { data: { ids } });
    dispatch(deleteCouponsSuccess(ids));
    Store.addNotification(COMMON_DATA_DELETE_SUCCESS(translations));
    return true;
  } catch (e) {
    dispatch(deleteCouponsFail(e));
    Store.addNotification(COMMON_DATA_DELETE_FAIL(translations));
    return false;
  }
};

export const fetchDiscountSettings = () => async (dispatch) => {
  dispatch(fetchDiscountSettingsStart());
  try {
    const result = await get('/discounts/settings');
    dispatch(fetchDiscountSettingsSuccess(result.data));
    return result.data;
  } catch (e) {
    dispatch(fetchDiscountSettingsFail(e));
    return false;
  }
};

export const updateDiscountSettings = (data, translations) => async (dispatch) => {
  dispatch(updateDiscountSettingsStart());
  try {
    const result = await put('/discounts/settings', data);
    dispatch(updateDiscountSettingsSuccess(result.data));
    Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    return result.data;
  } catch (e) {
    dispatch(updateDiscountSettingsFail(e));
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    return false;
  }
};
